// extracted by mini-css-extract-plugin
export default {"links":"top-links-links--ec60c"};